//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";

export default {
    name: "AQDeniedPage",
    components: {
        AQButton
    },
    props: {
        showRightsReserved: {
            type: Boolean,
            default: false
        },
        isSupportedBrowser: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters("main", ["getInfoApp"]),
        getYear() {
            return new Date().getFullYear();
        }
    },
    methods: {
        redirectToPage() {
            this.$router.push("/");
        }
    }
};
